// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 用户登录
export function login(data) {
  return request({
    url: "/api/login/login",
    method: "post",
    data,
  });
}

// 退出登录
export function outLogin(headers) {
  return request({
    url: "/api/login/out_login",
    method: "get",
    headers,
  });
}

// 注册
export function register(data) {
  return request({
    url: "/api/login/register",
    method: "post",
    data,
  });
}

// 获取学段
export function get_grade_group() {
  return request({
    url: "/api/common/get_grade_group",
    method: "get",
  });
}

// 获取年级
export function get_grade() {
  return request({
    url: "/api/common/get_grade",
    method: "get",
  });
}

//获取协议内容
export function getAgreement(params) {
  return request({
    url: "/api/config/agreement",
    method: "get",
    params
  });
}



//微信登录
export function login_wechat_login(params) {
  return request({
    url: "/api/login/wechat_login",
    method: "get",
    params
  });
}


export function login_wechat_bind_info(data) {
  return request({
    url: "/api/login/wechat_bind_info",
    method: "post",
    data,
  });
}


